export default "/images/vendor/@material-design-icons/svg/outlined/download.svg?8bed23b557e3f932e2faa57db42f7890";